import { z } from 'zod'

export const TaskStatus = z.enum(['todo', 'in_progress', 'done'])
export type TaskStatus = z.infer<typeof TaskStatus>

export const TaskAssigneeSchema = z.object({
  profile_id: z.string().uuid(),
  full_name: z.string(),
})
export type TaskAssignee = z.infer<typeof TaskAssigneeSchema>

export const TaskSchema = z.object({
  id: z.string().uuid(),
  organization_id: z.string().uuid(),
  title: z.string().min(1).max(256),
  description: z.string().nullable(),
  status: TaskStatus,
  labels: z.array(z.string()),
  due_date: z.string().nullable(), // 'YYYY-MM-DD'
  email_id: z.string().nullable(),
  created_by: z.string().uuid(),
  created_at: z.string(),
  updated_at: z.string(),
})
export type Task = z.infer<typeof TaskSchema>

export const TaskWithAssigneesSchema = TaskSchema.extend({
  assignees: z.array(TaskAssigneeSchema),
})
export type TaskWithAssignees = z.infer<typeof TaskWithAssigneesSchema>

export const TaskCommentSchema = z.object({
  id: z.string().uuid(),
  task_id: z.string().uuid(),
  organization_id: z.string().uuid(),
  author_id: z.string().uuid(),
  body: z.string().min(1).max(4000),
  created_at: z.string(),
  author_name: z.string().optional(),
})
export type TaskComment = z.infer<typeof TaskCommentSchema>

export const CreateTaskInputSchema = z.object({
  title: z.string().min(1).max(256),
  description: z.string().optional(),
  status: TaskStatus.default('todo'),
  labels: z.array(z.string()).default([]),
  due_date: z.string().nullable().optional(),
  email_id: z.string().nullable().optional(),
  assignee_ids: z.array(z.string().uuid()).default([]),
})
export type CreateTaskInput = z.infer<typeof CreateTaskInputSchema>

export const UpdateTaskInputSchema = z.object({
  title: z.string().min(1).max(256).optional(),
  description: z.string().nullable().optional(),
  status: TaskStatus.optional(),
  labels: z.array(z.string()).optional(),
  due_date: z.string().nullable().optional(),
  assignee_ids: z.array(z.string().uuid()).optional(),
})
export type UpdateTaskInput = z.infer<typeof UpdateTaskInputSchema>
